import { resetMobileNav } from './mobile-nav-menus';

// Slide In Nav
const removeClass = (selector, toggle) => {
  selector.classList.remove(toggle);
};

const toggleClass = (selector, toggle) => {
  selector.classList.toggle(toggle);
  if (selector.classList.contains('slide-in')) {
    resetMobileNav();
  }
};

const addListeners = (eventType, options) => {
  let {
    selector,
    toggle,
    activator,
    notActive,
  } = options;

  const {
    breakpoint,
  } = options;

  selector = document.querySelector(selector);
  toggle = toggle.replace(/\W/, '');
  activator = document.querySelector(activator);
  notActive = document.querySelector(notActive);
  document.addEventListener(eventType, (event) => {
    event.stopPropagation();
    removeClass(selector, toggle);
  });
  notActive.addEventListener(eventType, (event) => {
    event.stopPropagation();
  });
  activator.addEventListener(eventType, (event) => {
    event.stopPropagation();
    toggleClass(selector, toggle);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= breakpoint) {
      removeClass(selector, toggle);
      resetMobileNav();
    }
  });
};

const init = (options) => {
  addListeners((navigator.userAgent.match(/(iPad|iPhone)/i) ? 'touchend' : 'click'), options);
};

export default {
  init,
};
